import { ReactComponent as ErrorIcon } from './error.svg';

export default ErrorIcon;
